/** @jsx jsx */
import momentUtils from '@date-io/moment';
import { jsx } from '@emotion/core';
import { Box, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import Calendar from 'icons/Calendar';
import moment, { Moment } from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { CustomTypography, InputDateDiv, StyledDatepicker } from './Input.styled';

interface IProps extends FieldRenderProps<Moment | undefined> {
  label?: string;
  width?: string;
}

type PropType = IProps;

const CustomDatepicker = ({ input, meta: { error, touched }, label, width }: PropType): JSX.Element => {
  const [date, setDate] = useState<Moment | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    const { onChange } = input;

    if (input.value) {
      onChange(input.value);
      setDate(input.value);
    }
  }, []);

  useEffect(() => {
    const { onChange } = input;

    if (input.value) {
      onChange(input.value);
      setDate(input.value);
    }
  }, [input.value]);

  useEffect(() => {
    const { onChange } = input;

    if (date === null) {
      onChange(undefined);
    } else {
      const now = moment();

      if (date.isBefore(now)) {
        date.hour(now.hour() + 1).minute(0);
      }
      onChange(date);
    }
  }, [date]);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleClear = (): void => {
    setDate(null);
  };

  const renderEndAdornment = (): JSX.Element => (
    <Fragment>
      {date && (
        <IconButton size="small" onClick={handleClear}>
          <CloseIcon />
        </IconButton>
      )}
      <Box
        height="32px"
        minWidth="32px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderColor="#c4c4c4"
        borderLeft="1px solid"
      >
        <IconButton size="small" onClick={handleOpen}>
          <Calendar />
        </IconButton>
      </Box>
    </Fragment>
  );

  const shouldDisplayError = !!error && touched;

  return (
    <InputDateDiv width={width}>
      {label && (
        <CustomTypography color="textSecondary" variant="subtitle2">
          {t(label)}
        </CustomTypography>
      )}
      <MuiPickersUtilsProvider utils={momentUtils}>
        <StyledDatepicker
          error={shouldDisplayError}
          disableToolbar
          disablePast
          size="small"
          views={['date', 'hours']}
          ampm={false}
          margin="dense"
          inputVariant="outlined"
          {...input}
          InputProps={{
            endAdornment: renderEndAdornment(),
          }}
          open={open}
          value={date}
          onChange={(value): void => {
            setDate((value as Moment).minutes(0));
          }}
          onClose={handleClose}
          onAccept={handleClose}
          placeholder={t('common.selectPlaceholder')}
          DialogProps={{
            disablePortal: true,
            style: {
              inset: 'auto',
              transform: 'translate(0px, -390px)',
            },
            PaperProps: {
              style: {
                boxShadow: '0px 3px 6px rgb(0 0 0 / 23%)',
              },
            },
          }}
        />
      </MuiPickersUtilsProvider>
      {shouldDisplayError && (
        <Typography variant="caption" color="error">
          {t(error as string)}
        </Typography>
      )}
    </InputDateDiv>
  );
};

export default CustomDatepicker;
